<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Course History
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row class="text-left">
        <v-col md="12">
          <div>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              v-show="!loading"
              :items="courseHistory"
            >
                <template v-slot:item.certificate_url="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                          <v-btn
                          v-on="on"
                          outlined
                          small
                          class="mr-1 action-button action-button-txt"
                          @click.prevent="downloadCertificate(item.certificate_url)"
                          >
                              <span>View Certificate</span>
                          </v-btn>
                      </template>
                  <span>Archived Data</span>
                </v-tooltip>
                </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import courseAPI from "@/api/course.js";
    export default {
        name: "CourseHistory",
        props: {
            id: {
                type: String,
                default: null
            },
            params: {
                type: String,
                default: ""
            },
            
        },
        data() {
            return {
                headers: [
                    { text: "Started Date", value: "start_date" },
                    { text: "Completed Date", value: "complete_date" },
                    { text: "Progress", value: "progress" },
                    { text: "Test Score", value: "test_score" },
                    { text: "Attempts", value: "attempts" },
                    { text: "Archive Status", value: "is_manual" },
                    { text: "", value: "certificate_url", align: "end" }

                ],
                courseHistory: [],
                search: "",
                searchParams: "",
                pagination: {},
                options: {},
                loading: false,
            };
        },
        computed: {
            /*serverItemsLength: function() {
              return this.pagination.total;
            },
            itemsPerPage: function() {
              return this.pagination.per_page;
            },
            page: function() {
              return this.pagination.current_page;
            },
            params: function() {
              return (
                this.$gf.getQueryString(this.options, this.serverItemsLength) + this.searchParams + "&include="
              );
            }*/
            isTabletOrDesktop() {
              const width = this.$vuetify.breakpoint.width;
              return width >= 820;
            },
        },
        mounted() {
            this.getUserCourseHistory();
          },
        /*watch: {
            options: {
              handler() {
                this.getUserCourseHistory();
              },
              deep: true
            }
        },*/
        methods: {
            getUserCourseHistory() {
                this.loading = true;
                courseAPI
                .getUserCourseHistory(this.id)
                .then(resp => {
                    this.courseHistory = resp.data.data;
                    //this.pagination = resp.data.meta.pagination;
                    this.loading = false;
                });
            },
            setEventBus() {
                EventBus.$on("DATE_SELECTED", date => {
                    this.deadlineSet = true;
                    this.selectedDate = date;
                });
            },
            closePanel() {
                this.$emit("closePanel", {});
            },
            downloadCertificate(url) {
              window.open(url, "_blank");
            }
        }
    };
</script>
<style media="screen">
#slideout-container {
    height: calc(100vh - 65px - 100px);
}
.max-height-list {
    height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
    transition: none;
}
.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex:none;
}
</style>
